// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  MASTER_PAGE_TOOGLE_MENU,
} from './constants';

export function toogleMenu() {
  return {
    type: MASTER_PAGE_TOOGLE_MENU,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MASTER_PAGE_TOOGLE_MENU:
      return {
         ...state, menu: {open : !state.menu.open}
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/master-page/redux/toogleMenu.js